// extracted by mini-css-extract-plugin
module.exports = {"navBar":"navBar_navBar__1HpeI","link_local":"navBar_link_local__3G1GM","menu_button":"navBar_menu_button__3aXYg"};